import React from 'react'
import { UnderlinedButton } from 'jl-design-system/elements/button/Button'
import { SecondaryLink } from 'jl-design-system/elements/link/Link'
import requestNewLink from '../../../utils/auth0/requestNewLink'
import styles from './PasswordlessLinkUsedError.scss'

type Props = {
  code: string
}

export default function PasswordlessLinkUsedError({ code }: Props) {
  return (
    <div className={styles.container} data-testid="passwordless-link-used-error">
      <section className={styles.section}>
        <p className={styles.title}>Sign-in links can only be used once</p>
        <p className={styles.body}>
          If you&apos;ve used this link already, please{' '}
          <UnderlinedButton onClick={() => requestNewLink(code)} data-testid="request-new-link">
            request another link
          </UnderlinedButton>
        </p>
      </section>
      <section className={styles.section}>
        <p className={styles.title}>Requested more than one link?</p>
        <p className={styles.body}>
          Links expire whenever you request a new one. Make sure you use the most recent one sent to
          you.
        </p>
      </section>

      <div className={styles.cta}>
        <SecondaryLink to="/#homepage" external data-testid="error-cta">
          Go to homepage
        </SecondaryLink>
      </div>
    </div>
  )
}
